import * as turf from "@turf/turf";
import { formatArea } from "./formatting";
import { getVertexLabel } from "./helpers";

/**
 * Converts a polygon into an array of line features.
 */
export const polygonToLines = (polygon) => {
  const coordinates = polygon.geometry.coordinates[0];
  const lineFeatures = [];
  for (let i = 0; i < coordinates.length - 1; i++) {
    const start = coordinates[i];
    const end = coordinates[i + 1];
    const labelStart = getVertexLabel(i);
    // When wrapping around, use 0 for the second label on the last edge.
    const labelEnd = getVertexLabel(i === coordinates.length - 2 ? 0 : i + 1);
    lineFeatures.push({
      type: "Feature",
      properties: {
        id: `${polygon.id}_${i}`,
        lineName: `${labelStart}${labelEnd}`,
      },
      geometry: {
        type: "LineString",
        coordinates: [start, end],
      },
    });
  }
  return lineFeatures;
};

/**
 * Creates an array of distance label features and vertex label features for a given polygon.
 * @param {object} polygon - A GeoJSON Feature (Polygon)
 * @returns {{ distanceFeatures: object[], vertexFeatures: object[] }}
 */
export function createDistanceAndVertexFeatures(polygon) {
  const distanceFeatures = [];
  const vertexFeatures = [];

  if (!polygon || polygon.geometry.type !== "Polygon") return { distanceFeatures, vertexFeatures };

  const coords = polygon.geometry.coordinates[0];
  for (let i = 0; i < coords.length - 1; i++) {
    const from = turf.point(coords[i]);
    const to = turf.point(coords[i + 1]);
    const distance = turf.distance(from, to, { units: "meters" });
    const midpoint = turf.midpoint(from, to);

    distanceFeatures.push({
      type: "Feature",
      geometry: midpoint.geometry,
      properties: { distance: `${distance.toFixed(2)} m` },
    });

    const label = getVertexLabel(i); // 'A', 'B', etc.
    vertexFeatures.push({
      type: "Feature",
      geometry: { type: "Point", coordinates: coords[i] },
      properties: { label: label.toUpperCase() },
    });
  }

  return { distanceFeatures, vertexFeatures };
}
